import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';

const LANGUAGES = [
    { code: 'en', colorId: 6, name: 'English', englishName: 'English' },
    { code: 'de', colorId: 1, name: 'Deutsch', englishName: 'German' },
    { code: 'es', colorId: 4, name: 'Español', englishName: 'Spanish' },
    { code: 'ru', colorId: 0, name: 'Русский', englishName: 'Russian' },
    { code: 'tr', colorId: 7, name: 'Türkçe', englishName: 'Turkish' },
    { code: 'fr', colorId: 9, name: 'Français', englishName: 'French' },
    { code: 'it', colorId: 2, name: 'Italiano', englishName: 'Italian' },
    { code: 'pl', colorId: 1, name: 'Polski', englishName: 'Polish' },
    { code: 'ko', colorId: 9, name: '한국인', englishName: 'Korean' }
];

const SettingsLanguage = () => {
    const { t, i18n } = useTranslation();
    const history = useHistory();
    const location = useLocation();

    // Текущий выбранный язык
    const currentLang = i18n.language || 'ru';

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = 'unset'; };
    }, []);

    const handleClose = () => {
        if (location.state && location.state.background) {
            history.goBack();
        } else {
            // Если открыли по прямой ссылке, кидаем в корень настроек
            history.push('/settings');
        }
    };

    const handleLanguageSelect = (langCode) => {
        // Меняем язык через i18next
        i18n.changeLanguage(langCode);
        // Сохраняем в localStorage, чтобы при перезагрузке язык не сбрасывался
        localStorage.setItem('i18nextLng', langCode);

        // Закрываем окно после выбора
        handleClose();
    };

    return (
        <div className="settings-overlay" onClick={handleClose}>
            <div className="settings-modal" onClick={(e) => e.stopPropagation()}>

                <button className="settings-modal__close" onClick={handleClose}>×</button>

                <div className="settings-modal__content">

                    <h2 className="settings-modal__title">
                        {t('translate.setting_language1')}
                    </h2>

                    {/* Список языков */}
                    <div className="lang-list">
                        {LANGUAGES.map((lang) => {
                            const isActive = currentLang.includes(lang.code);

                            return (
                                <div
                                    key={lang.code}
                                    className={`lang-item lang-color--${lang.colorId} ${isActive ? 'lang-item--active' : ''}`}
                                    onClick={() => handleLanguageSelect(lang.code)}
                                >
                                    <div className="lang-item__circle">
                                        {lang.code.toUpperCase()}
                                    </div>
                                    <div className="lang-item__text">
                                        <h4 className="lang-item__name">{lang.name}</h4>
                                        <p className="lang-item__en-name">{lang.englishName}</p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                </div>
            </div>
        </div>
    );
};

export default SettingsLanguage;